import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import axios from '../../utils/axios';
import { CONSTS } from './const';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import { dispatch } from '../store';
import { GetFeaturesData } from '../../@types/features';

type FeaturesState = {
  featuresPayload: GetFeaturesData[] | null
  featuresError: boolean;
  featuresLoading: boolean;
};

const initialState: FeaturesState = {
  featuresPayload: null,
  featuresError: false,
  featuresLoading: true
};

const slice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    getFeaturesSuccess(state, action) {
      state.featuresPayload = action.payload;
      state.featuresError = false;
      state.featuresLoading = false;
    },

    hasErrorGetFeaturesSuccess(state) {
      state.featuresPayload = [];
      state.featuresError = true;
      state.featuresLoading = false;
    },

    getFeaturesLoading(state) {
      state.featuresLoading = true;
    }
  }
});

export default slice.reducer;

export async function getFeaturesWithReturn() {
  try {
    const response: AxiosResponseModel<GetFeaturesData[]> = await axios
      .get(`${CONSTS.CONSTANTS_GET_GET_ALL_FEATURES}`)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // dispatch(
      //   slice.actions.getFeaturesSuccess(response.data?.data || null)
      // );
      return response.data?.data || null;
    }
    // dispatch(slice.actions.hasErrorGetFeaturesSuccess());
    return null;
  } catch (error: any) {
    // dispatch(slice.actions.hasErrorGetFeaturesSuccess());
    return null;
  }
}

export async function getFeatures() {
  try {
    dispatch(slice.actions.getFeaturesLoading());
    const response: AxiosResponseModel<GetFeaturesData[]> = await axios
      .get(`${CONSTS.CONSTANTS_GET_GET_ALL_FEATURES}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorGetFeaturesSuccess());
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.getFeaturesSuccess(response.data?.data || null)
      );
      // return response.data?.data || null;
      return
    }
    dispatch(slice.actions.hasErrorGetFeaturesSuccess());
    // return null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorGetFeaturesSuccess());
    // return null;
  }
}
